import { useSyncExternalStore } from "react";

/**
 * Store global ultra-léger pour piloter l'ouverture du drawer mobile
 * de la sidebar depuis n'importe quel composant (burger trigger dans
 * un header / overlay backdrop / item de nav qui se ferme après clic).
 */
let isOpen = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openMobileNav() {
  if (!isOpen) {
    isOpen = true;
    emit();
  }
}

export function closeMobileNav() {
  if (isOpen) {
    isOpen = false;
    emit();
  }
}

export function toggleMobileNav() {
  isOpen = !isOpen;
  emit();
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

function getSnapshot() {
  return isOpen;
}

/**
 * Hook React pour s'abonner à l'état d'ouverture du drawer mobile.
 *
 * @example
 *   const open = useMobileNav();
 *   <div className={open ? "translate-x-0" : "-translate-x-full"}>...</div>
 */
export function useMobileNav() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
